export const LOAD_VENUE_DETAILS = 'LOAD_VENUE_DETAILS';
export type LOAD_VENUE_DETAILS = typeof LOAD_VENUE_DETAILS;

export const LOAD_UNLISTED_VENUE = 'LOAD_UNLISTED_VENUE';
export type LOAD_UNLISTED_VENUE = typeof LOAD_UNLISTED_VENUE;

export const LOAD_PERSONALIZED_VENUE_DETAILS = 'LOAD_PERSONALIZED_VENUE_DETAILS';
export type LOAD_PERSONALIZED_VENUE_DETAILS = typeof LOAD_PERSONALIZED_VENUE_DETAILS;

export const NEXT_VENUE_IMAGES_SLIDE = 'NEXT_VENUE_IMAGES_SLIDE';
export type NEXT_VENUE_IMAGES_SLIDE = typeof NEXT_VENUE_IMAGES_SLIDE;

export const PREV_VENUE_IMAGES_SLIDE = 'PREV_VENUE_IMAGES_SLIDE';
export type PREV_VENUE_IMAGES_SLIDE = typeof PREV_VENUE_IMAGES_SLIDE;

export const TOGGLE_MOBILE_NAVBAR = 'TOGGLE_MOBILE_NAVBAR';
export type TOGGLE_MOBILE_NAVBAR = typeof TOGGLE_MOBILE_NAVBAR;

export const OPEN_MENU_ITEM = 'OPEN_MENU_ITEM';
export type OPEN_MENU_ITEM = typeof OPEN_MENU_ITEM;

export const CLOSE_MENU_ITEM = 'CLOSE_MENU_ITEM';
export type CLOSE_MENU_ITEM = typeof CLOSE_MENU_ITEM;

export const CLOSE_MOBILE_NAVBAR = 'CLOSE_MOBILE_NAVBAR';
export type CLOSE_MOBILE_NAVBAR = typeof CLOSE_MOBILE_NAVBAR;

export const OPEN_MOBILE_NAVBAR = 'OPEN_MOBILE_NAVBAR';
export type OPEN_MOBILE_NAVBAR = typeof OPEN_MOBILE_NAVBAR;

export const OPEN_ACCOUNT_MENU = 'OPEN_ACCOUNT_MENU';
export type OPEN_ACCOUNT_MENU = typeof OPEN_ACCOUNT_MENU;

export const CLOSE_ACCOUNT_MENU = 'CLOSE_ACCOUNT_MENU';
export type CLOSE_ACCOUNT_MENU = typeof CLOSE_ACCOUNT_MENU;

export const OPEN_LOCATIONS_MENU = 'OPEN_LOCATIONS_MENU';
export type OPEN_LOCATIONS_MENU = typeof OPEN_LOCATIONS_MENU;

export const CLOSE_LOCATIONS_MENU = 'CLOSE_LOCATIONS_MENU';
export type CLOSE_LOCATIONS_MENU = typeof CLOSE_LOCATIONS_MENU;

export const OPEN_SUBHEADER_MENU = 'OPEN_SUBHEADER_MENU';
export type OPEN_SUBHEADER_MENU = typeof OPEN_SUBHEADER_MENU;

export const CLOSE_SUBHEADER_MENU = 'CLOSE_SUBHEADER_MENU';
export type CLOSE_SUBHEADER_MENU = typeof CLOSE_SUBHEADER_MENU;

export const HEADER_DATA_LOADED = 'HEADER_DATA_LOADED';
export type HEADER_DATA_LOADED = typeof HEADER_DATA_LOADED;

export const VENUE_HEADER_DATA_LOADED = 'VENUE_HEADER_DATA_LOADED';
export type VENUE_HEADER_DATA_LOADED = typeof VENUE_HEADER_DATA_LOADED;

export const SHOW_PHONE_NUMBER = 'SHOW_PHONE_NUMBER';
export type SHOW_PHONE_NUMBER = typeof SHOW_PHONE_NUMBER;

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export type SET_ACTIVE_TAB = typeof SET_ACTIVE_TAB;

export const OPEN_MORE_TAB = 'OPEN_MORE_TAB';
export type OPEN_MORE_TAB = typeof OPEN_MORE_TAB;

export const CLOSE_MORE_TAB = 'CLOSE_MORE_TAB';
export type CLOSE_MORE_TAB = typeof CLOSE_MORE_TAB;

export const SET_USER_AUTHED = 'SET_USER_AUTHED';
export type SET_USER_AUTHED = typeof SET_USER_AUTHED;

export const SET_USER_ANONYMOUS = 'SET_USER_ANONYMOUS';
export type SET_USER_ANONYMOUS = typeof SET_USER_ANONYMOUS;

export const SET_VENUE_AS_FAVORITE = 'SET_VENUE_AS_FAVORITE';
export type SET_VENUE_AS_FAVORITE = typeof SET_VENUE_AS_FAVORITE;

export const UNSET_VENUE_FROM_FAVORITE = 'UNSET_VENUE_FROM_FAVORITE';
export type UNSET_VENUE_FROM_FAVORITE = typeof UNSET_VENUE_FROM_FAVORITE;

export const SET_USER_INFO = 'SET_USER_INFO';
export type SET_USER_INFO = typeof SET_USER_INFO;

export const SET_USER_PREFERENCES = 'SET_USER_PREFERENCES';
export type SET_USER_PREFERENCES = typeof SET_USER_PREFERENCES;

export const ADD_SERVER_ERROR = 'ADD_SERVER_ERROR';
export type ADD_SERVER_ERROR = typeof ADD_SERVER_ERROR;

export const NAVIGATED_TO_VENUE_PROFILE = 'NAVIGATED_TO_VENUE_PROFILE';
export type NAVIGATED_TO_VENUE_PROFILE = typeof NAVIGATED_TO_VENUE_PROFILE;

export const NAVIGATED_AWAY_FROM_VENUE_PROFILE = 'NAVIGATED_AWAY_FROM_VENUE_PROFILE';
export type NAVIGATED_AWAY_FROM_VENUE_PROFILE = typeof NAVIGATED_AWAY_FROM_VENUE_PROFILE;

export const VENUE_PROFILE_RECOMMENDATIONS_LOADED = 'LOAD_VENUE_PROFILE_RECOMMENDATIONS';
export type VENUE_PROFILE_RECOMMENDATIONS_LOADED = typeof VENUE_PROFILE_RECOMMENDATIONS_LOADED;

export const VENUE_PROFILE_RECOMMENDATIONS_FAILED = 'VENUE_PROFILE_RECOMMENDATIONS_FAILED';
export type VENUE_PROFILE_RECOMMENDATIONS_FAILED = typeof VENUE_PROFILE_RECOMMENDATIONS_FAILED;

export const VENUE_PROFILE_SHOW_INQUIRY_MODAL = 'VENUE_PROFILE_SHOW_INQUIRY_MODAL';
export type VENUE_PROFILE_SHOW_INQUIRY_MODAL = typeof VENUE_PROFILE_SHOW_INQUIRY_MODAL;

export const VENUE_PROFILE_HIDE_INQUIRY_MODAL = 'VENUE_PROFILE_HIDE_INQUIRY_MODAL';
export type VENUE_PROFILE_HIDE_INQUIRY_MODAL = typeof VENUE_PROFILE_HIDE_INQUIRY_MODAL;

export const VENUE_PROFILE_RENDER_RDV = 'VENUE_PROFILE_RENDER_RDV';
export type VENUE_PROFILE_RENDER_RDV = typeof VENUE_PROFILE_RENDER_RDV;

export const SHOW_PARTNERS_SIGNUP_MODAL = 'SHOW_PARTNERS_SIGNUP_MODAL';
export type SHOW_PARTNERS_SIGNUP_MODAL = typeof SHOW_PARTNERS_SIGNUP_MODAL;

export const SHOW_OFFER_MODAL = 'SHOW_OFFER_MODAL';
export type SHOW_OFFER_MODAL = typeof SHOW_OFFER_MODAL;

export const HIDE_OFFER_MODAL = 'HIDE_OFFER_MODAL';
export type HIDE_OFFER_MODAL = typeof HIDE_OFFER_MODAL;

export const LOAD_LANDING_PAGE_DATA = 'LOAD_LANDING_PAGE_DATA';
export type LOAD_LANDING_PAGE_DATA = typeof LOAD_LANDING_PAGE_DATA;

export const LOAD_BARN_PAGE_DATA = 'LOAD_BARN_PAGE_DATA';
export type LOAD_BARN_PAGE_DATA = typeof LOAD_BARN_PAGE_DATA;

export const LOAD_LANDING_PAGE_RECOMMENDED_VENUES = 'LOAD_LANDING_PAGE_RECOMMENDED_VENUES';
export type LOAD_LANDING_PAGE_RECOMMENDED_VENUES = typeof LOAD_LANDING_PAGE_RECOMMENDED_VENUES;

export const LANDING_PAGE_LOADED = 'LANDING_PAGE_LOADED';
export type LANDING_PAGE_LOADED = typeof LANDING_PAGE_LOADED;

export const LOAD_ALL_STYLES_LANDING_PAGE_DATA = 'LOAD_ALL_STYLES_LANDING_PAGE_DATA';
export type LOAD_ALL_STYLES_LANDING_PAGE_DATA = typeof LOAD_ALL_STYLES_LANDING_PAGE_DATA;

export const LOAD_MASS_INQUIRY_VENUES = 'LOAD_MASS_INQUIRY_VENUES';
export type LOAD_MASS_INQUIRY_VENUES = typeof LOAD_MASS_INQUIRY_VENUES;

export const LOAD_SEARCH_RESULTS = 'LOAD_SEARCH_RESULTS';
export type LOAD_SEARCH_RESULTS = typeof LOAD_SEARCH_RESULTS;

export const SEARCH_RESULTS_LOADED = 'SEARCH_RESULTS_LOADED';
export type SEARCH_RESULTS_LOADED = typeof SEARCH_RESULTS_LOADED;

export const SEARCH_ERRORED = 'SEARCH_ERRORED';
export type SEARCH_ERRORED = typeof SEARCH_ERRORED;

export const LOAD_SEARCH_FILTERS = 'LOAD_SEARCH_FILTERS';
export type LOAD_SEARCH_FILTERS = typeof LOAD_SEARCH_FILTERS;

export const SEARCH_FILTERS_LOADED = 'SEARCH_FILTERS_LOADED';
export type SEARCH_FILTERS_LOADED = typeof SEARCH_FILTERS_LOADED;

export const SEARCH_FILTERS_ERRORED = 'SEARCH_FILTERS_ERRORED';
export type SEARCH_FILTERS_ERRORED = typeof SEARCH_FILTERS_ERRORED;

export const LOAD_SEARCH_PERSONALIZED_DATA = 'LOAD_SEARCH_PERSONALIZED_DATA';
export type LOAD_SEARCH_PERSONALIZED_DATA = typeof LOAD_SEARCH_PERSONALIZED_DATA;

export const SEARCH_PERSONALIZED_DATA_LOADED = 'SEARCH_PERSONALIZED_DATA_LOADED';
export type SEARCH_PERSONALIZED_DATA_LOADED = typeof SEARCH_PERSONALIZED_DATA_LOADED;

export const SEARCH_PERSONALIZED_DATA_ERRORED = 'SEARCH_PERSONALIZED_DATA_ERRORED';
export type SEARCH_PERSONALIZED_DATA_ERRORED = typeof SEARCH_PERSONALIZED_DATA_ERRORED;

export const LOAD_SEARCH_METADATA = 'LOAD_SEARCH_METADATA';
export type LOAD_SEARCH_METADATA = typeof LOAD_SEARCH_METADATA;

export const SEARCH_METADATA_LOADED = 'SEARCH_METADATA_LOADED';
export type SEARCH_METADATA_LOADED = typeof SEARCH_METADATA_LOADED;

export const SEARCH_METADATA_ERRORED = 'SEARCH_METADATA_ERRORED';
export type SEARCH_METADATA_ERRORED = typeof SEARCH_METADATA_ERRORED;

export const SMALL_STYLE = 'small';
export const SMALL_STYLE_SRP_DEFAULT_MAX_GUEST_COUNT = 50;

export const LUXURY_STYLE = 'luxury';
export const LUXURY_STYLE_SRP_DEFAULT_MIN_BUDGET = 50000;

export const LIST_VIEW = 'list_view';

export { SRP_VIEWS } from '@weddingspot/ws-core-components';

export const LIST_VIEW_BREAKPOINTS = {
    LIST:1080,
    MAP:816,
}